import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { PlainTextCustomFieldFilterControls } from '~/components/Filters/CustomFieldFilter/PlainTextCustomFieldFilterControls';
import { type BaseFilterCardProps, FilterCard } from '~/components/Filters/FilterCard';
import { type CustomFieldFilterType } from '~/components/FiltersMenu/types';
import { clearCustomFieldFilterValuesAction, removeFilterAction } from '~/store/filters/actions';
import { type SelectedFilter } from '~/store/filters/types';

export type PlainTextCustomFieldFilterCardProps = {
  customField: CustomFieldFilterType;
} & BaseFilterCardProps;

export const PlainTextCustomFieldFilterCard = memo(({ customField, ...props }: PlainTextCustomFieldFilterCardProps) => {
  const dispatch = useDispatch();
  const customFieldId = customField.id;

  const clearValues = useCallback(() => {
    dispatch(clearCustomFieldFilterValuesAction({ customFieldId }));
  }, [customFieldId, dispatch]);

  const onRemoveFilter = useCallback(
    (filter: SelectedFilter) => {
      dispatch(removeFilterAction({ filter }));
      clearValues();
    },
    [clearValues, dispatch],
  );

  return (
    <FilterCard
      currentFilter="customField"
      currentCustomField={customField}
      onClearClick={clearValues}
      onRemoveFilter={onRemoveFilter}
      {...props}
    >
      <PlainTextCustomFieldFilterControls customFieldId={customFieldId} fieldName={customField.name} />
    </FilterCard>
  );
});

PlainTextCustomFieldFilterCard.displayName = 'PlainTextCustomFieldFilterCard';
